module.exports = __webpack_public_path__ + "static/Fav_32px-7bbd50c2e9f0350e4905a900e80228ce.ico";